import { GetServerSideProps } from 'next'
import type { EducatorCohortDetailsResponse } from '@mc/api'
import { getSubjectData, getNavSubjects } from '../../data/subjects'
import { SubjectLandingPage } from '../../features/SubjectLandingPage/SubjectLandingPage'
import type { SubjectLandingData } from '../../types/subjects'
import { getCohortDetailsForSeed } from '../../utils/enrollmentStatus'
import { getPageTitle } from '../../utils/pageTitle'
import { getServerSidePropsWithProductPrice } from '../../utils/pricing'

interface SubjectPageProps {
  slug: string
  subjectData: SubjectLandingData
  subjects: { slug: string; name: string; comingSoon?: boolean }[]
  title: string
  cohortDetails?: EducatorCohortDetailsResponse | null
}

const SubjectPage = ({
  slug,
  subjectData,
  subjects,
  cohortDetails,
}: SubjectPageProps) => (
  <SubjectLandingPage
    key={slug}
    slug={slug}
    subjectData={subjectData}
    subjects={subjects}
    initialCohortDetails={cohortDetails ?? undefined}
  />
)

SubjectPage.pageSettings = {
  pageName: 'subject-landing',
}

export const getServerSideProps: GetServerSideProps =
  getServerSidePropsWithProductPrice(async (ctx) => {
    const { slug } = ctx.params as { slug: string }

    const subjectData = getSubjectData(slug)

    if (!subjectData) {
      return { notFound: true }
    }

    const subjects = getNavSubjects()

    // Seed the hero strip + CTAs so they render correctly on first paint (no flash).
    const cohortDetails = await getCohortDetailsForSeed()

    return {
      props: {
        slug,
        subjectData,
        subjects,
        title: getPageTitle(subjectData.hero.categoryLabel),
        cohortDetails,
      },
    }
  })

export default SubjectPage
